import { iconSvg } from './appsGrid';

export const FEED_ITEMS = [
  ['PERFORMANCE', '#F2A73A', 'bars', '<b>18 members</b> are performing below their 4-week baseline', 'See who'],
  ['FLIGHT RISK', '#F2673A', 'warn', '<b>19 members</b> show job-search activity during work hours', 'View pattern'],
  ['RESOURCES', '#469FD8', 'net', '<b>Green Soul</b> is under-staffed — 3 people carry 70% of the load', 'Rebalance'],
  ['TEAM WIN', '#34A851', 'flag', '<b>Team Alice</b> closed 34 deliverables — best sprint this quarter', 'Send kudos'],
  ['CRM', '#366EB6', 'user', 'Leads are logged <b>6 hours late</b> — new leads need faster routing', 'Fix routing'],
  ['HRMS', '#6C59A6', 'cal', '<b>Rikesh’s</b> leave pattern looks unusual — a quiet 1:1 may help', 'Plan a call'],
  ['SECURITY', '#E0483D', 'shield', '<b>Unusual activity</b> on Rob’s machine — bulk transfers at 1 AM', 'Review now'],
  ['FOCUS', '#2DBDB8', 'eye', 'Engineering deep-focus <b>up 14%</b> after no-meeting Wednesdays', 'Keep it up'],
  ['EMAIL', '#469FD8', 'mail', '<b>42 client emails</b> in Sales have waited 48h+ for a reply', 'Nudge owners'],
  ['AI RADAR', '#8B75D7', 'radar', '<b>6 unapproved AI tools</b> detected in use across Design', 'Review tools'],
  ['MEETINGS', '#F2A73A', 'cal', 'Ops spends <b>41% of the week</b> in meetings — 2× company baseline', 'Trim calendar'],
  ['EARLY WARNING', '#F2673A', 'warn', '<b>Priya’s</b> engagement fell 35% in 2 weeks — attrition risk', 'Check in'],
];

export const ASK_TYPE_QS = [
  'Why did Sales slow down this week?',
  'Who is at burnout risk right now?',
  'Which project needs more people?',
  'What changed since Monday?',
];

export const CONTEXT_PAIRS = [
  { q: "Who's quietly burning out?", ans: 'Marketing is at 3× baseline after-hours. I rebalanced 4 tasks and flagged Priya for a check-in.', c: '#366EB6', s: 4, ts: 'Tue 4:12', impact: 'after-hours −38%', act: 'See pattern' },
  { q: 'Where did Tuesday go?', ans: '6.2h went to meetings — 4 of them recurring. I trimmed 2 standing calls off your calendar.', c: '#6C59A6', s: 3, ts: 'Wed 9:31', impact: '2.5h/week back', act: 'View calendar' },
  { q: 'Is this real progress?', ans: 'Output is up 12% this sprint — verified against focus patterns, not raw activity.', c: '#6C59A6', s: 5, ts: 'Fri 2:05', impact: '+12% verified', act: 'See evidence' },
  { q: "Who's overloaded right now?", ans: '3 people carry 70% of Green Soul. I reassigned 2 tasks to Dev and Sarah.', c: '#366EB6', s: 4, ts: 'Mon 9:02', impact: 'load 70% → 48%', act: 'View breakdown' },
  { q: 'Why did leads go cold?', ans: 'Leads sat 6h before logging. I fixed the routing — replies now land under 2h.', c: '#007A6E', s: 2, ts: 'Thu 11:47', impact: 'reply time −67%', act: 'Open pipeline' },
  { q: 'Who never gets a reply?', ans: '42 client emails had waited 48h+. I nudged every owner — the queue is clear.', c: '#366EB6', s: 3, ts: 'Mon 8:54', impact: '42 cleared', act: 'Open queue' },
];

export function feedCardHtml(it) {
  return (
    `<span class="fico" style="background:${it[1]}22">${iconSvg(it[1], it[2])}</span>` +
    `<span class="ftxt"><span class="ftag" style="color:${it[1]}">${it[0]}<span class="fage">now</span></span>` +
    `<span class="fmsg">${it[3]}<button class="fact" style="color:${it[1]}">${it[4]}</button></span></span>`
  );
}

export function answerCardHtml(p) {
  const clock = p.ts.split(' ')[1];
  return (
    `<div class="ac-q"><span class="ac-you">You</span><span class="ac-qt">${p.q}</span><span class="ac-t">${p.ts}</span></div>` +
    `<div class="ac-a">` +
    `<img class="ac-av" src="/assets/mark-teamgrid.svg" alt=""/>` +
    `<div class="ac-m">` +
    `<div class="ac-head"><b>TeamGrid</b><span class="ac-t">${clock} · answered in ${p.s}s</span></div>` +
    `<div class="ac-body">${p.ans}</div>` +
    `<div class="ac-result"><svg aria-hidden="true" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M2 8.5 6 12.5 14 3.5"/></svg><span>${p.impact}</span><button class="ac-act" type="button">${p.act}</button></div>` +
    `</div></div>`
  );
}
